'use strict';

angular.module('randomization')
    .controller('RandomizationBlocksController', ['ShareCrfApiErrorCodes', 'RandomizationBlocksService', 'RecordRandomizationService', function(ShareCrfApiErrorCodes, RandomizationBlocksService, RecordRandomizationService) {
        var vm = this;

        vm.error = null;
        vm.loading = false;

        vm.items = [];
        vm.totalItems = 0;
        vm.orderBy = 'id';
        vm.orderReverse = true;
        vm.currentPage = 0;
        vm.limit = 25;

        vm.hasCohorts = RecordRandomizationService.hasCohorts();

        // información de los datos: elementos asignados/pendientes
        vm.blockStatus = {};

        vm.load = function() {
            vm.loading = true;
            vm.error = null;

            var parameters = _buildQueryParameters();

            return RandomizationBlocksService.list(parameters)
                .then(function(response) {
                    vm.items = response.data;
                    vm.totalItems = response.total;
                    vm.error = null;

                    _setBlocksInfo();
                })
                .catch(function(error) {
                    vm.items = [];
                    vm.totalItems = 0;
                    vm.error = ShareCrfApiErrorCodes.getHumanReadableMessage(error);
                })
                .finally(function() {
                    vm.loading = false;
                });
        };

        function _buildQueryParameters() {
            var parameters = {
                fields: ['id', 'cohort', 'data', 'createdAt', 'updatedAt'],
                limit: vm.limit,
                offset: vm.limit * vm.currentPage,
            };

            if (vm.orderBy) {
                parameters.order = vm.orderBy + ' ' + (vm.orderReverse ? 'desc' : 'asc');
            }

            return parameters;
        }

        function _setBlocksInfo() {
            angular.forEach(vm.items, function(item) {
                vm.blockStatus[item.id] = {
                    total: item.data.length,
                    assigned: 0,
                    pending: 0,
                };

                angular.forEach(item.data, function(branch) {
                    if (branch.used) {
                        vm.blockStatus[item.id].assigned++;
                    } else {
                        vm.blockStatus[item.id].pending++;
                    }
                });
            });
        }
    }]);
